import React, {useMemo, useState} from "react";
import "../style/Header.scss";
import logo from "../assets/images/Header/logo_green.png";
import languageImg from "../assets/images/Header/language.png";
import useWindowDimensions from "../util/Utils";
import {useNavigate} from "react-router-dom";

function Header(props) {
  let navigate = useNavigate();

  const {width} = useWindowDimensions();
  const isMobile = useMemo(() => {
    return width <= 780;
  }, [width]);

  const [selectedTab, setSelectedTab] = useState('');

  const onClickTabMenu = (tab) => {
    if(tab === ''){
      navigate('/');
    }
    else{
      setSelectedTab(tab);
      navigate(`/${tab}`);
    }
  }

  return (
      <div id={"Header"}>
        <div className="header-content-wrapper">
          <div className="logo-wrapper" onClick={()=>onClickTabMenu('')}>
            <img src={logo} alt="" className="logo-img"/>
          </div>
          <div className="tab-menu-wrapper">
            <div className={selectedTab === 'hub' ? "tab-menu selected":"tab-menu"} onClick={()=>onClickTabMenu('hub')}>VERIA HUB</div>
            <div className={selectedTab === 'explorer' ? "tab-menu selected middle":"tab-menu middle"} onClick={()=>onClickTabMenu('explorer')}>VERIA EXPLORER</div>
            <div className={selectedTab === 'docs' ? "tab-menu selected":"tab-menu"} onClick={()=>onClickTabMenu('docs')}>VERIA DOCS</div>
          </div>
          <div className="language-wrapper">
            <img src={languageImg} alt="" className="language-img"/>
            <div className="language-text">ENGLISH</div>
          </div>
        </div>
      </div>
  );
}

export default Header;
